import { type Profile } from "../profile.ts"

import * as UI from "@iyk/ui"

import { appConfig } from "../../app-config.ts"
import { GlobalRoutes } from "../../react-router/routes.ts"
import { Link as GlobalLink } from "../../ui/link.tsx"
import { Link, Routes } from "./link.tsx"
import { useScrollVisibility } from "./use-scroll-visibility.tsx"
import { UserMenu } from "./user-menu.tsx"

export const Header = ({ user }: { user?: Profile.User }) => {
  const { headerRef, isHidden, isScrolled } = useScrollVisibility()

  return (
    <header ref={headerRef} className={classForHeader({ isHidden, isScrolled })}>
      <Link to={Routes.home} className="content-center">
        <img
          src={appConfig.assets.images.logo.url}
          style={{ width: `${appConfig.assets.images.logo.width}px` }}
          alt={`${appConfig.artist.name} logo`}
        />
      </Link>
      {user ? (
        <UserMenu
          username={user.username}
          userId={user.id}
          totalCheckIns={user.attendedShowIds.length}
          totalMerchOwned={user.ownedMerchSkuIds.length}
        />
      ) : (
        <GlobalLink
          to={GlobalRoutes.login({ returnTo: GlobalRoutes.profile.home })}
          className={UI.classForButton({ size: "sm", kind: "shaded" })}
        >
          Login
        </GlobalLink>
      )}
    </header>
  )
}

const classForHeader = UI.cva(
  [
    "text-gray-12 sticky",
    "z-30 top-0 left-0 w-full h-[var(--header-height)] p-4",
    "flex item-center justify-between",
    "transition-all duration-300 ease-in-out"
  ],
  {
    variants: {
      isHidden: {
        true: "top-[calc(var(--header-height)*-1)]"
      },
      isScrolled: {
        true: "backdrop-blur-md bg-black/[85%]"
      }
    }
  }
)
